export const handleClear = (setAgentName: Function, setUsername: Function, setEmail: Function, setPhonenumber: Function, setInputValue: Function, setAddress: Function, setAddAgent: Function
) => {
  setAgentName("");
  setUsername("");
  setEmail("");
  setPhonenumber("");
  setInputValue("");
  setAddress("");
  setAddAgent(false);
};

export const handleCheckboxToggle = ( filter: boolean, setFilter: Function, setIsCheckboxClicked: Function, setSearchTerm: Function, filters: Function
) => {
  const newValue = !filter;
  setFilter(newValue);
  setIsCheckboxClicked(newValue);
  setSearchTerm("");
  filters(newValue);
};